export function validateIdentificationNo(
  id: string,
  isForeigner: boolean
): boolean {
  if (!id || id.trim() === '') return false

  if (isForeigner) {
    // Passport: typically alphanumeric, 6 to 9 chars (varies by country)
    const passportRegex = /^[A-Za-z0-9]{6,9}$/
    return passportRegex.test(id)
  }

  // Iranian National ID validation
  const iranIdRegex = /^\d{10}$/
  if (!iranIdRegex.test(id)) return false

  // Reject IDs with all identical digits (e.g., 0000000000, 1111111111, ...)
  if (/^(\d)\1{9}$/.test(id)) return false

  // Checksum validation for Iranian national code
  const check = parseInt(id[9], 10)
  const sum = id
    .substring(0, 9)
    .split('')
    .reduce((acc, cur, i) => acc + parseInt(cur, 10) * (10 - i), 0)

  const remainder = sum % 11
  return (
    (remainder < 2 && check === remainder) ||
    (remainder >= 2 && check === 11 - remainder)
  )
}
